import React from "react";
import { NavLink, Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import {
    FaChartPie, FaBox, FaFileInvoiceDollar, FaArrowLeft
} from "react-icons/fa";

const Sidebar = () => {
    const { user } = useAuth();
    const isAdmin = user?.role === "admin" || user?.role === "superadmin";

    const linkBase =
        "flex items-center gap-3 px-4 py-3 rounded-xl text-xs font-bold uppercase tracking-wider transition-all duration-200";

    const getActiveClass = () => "bg-[#E3B629] text-[#263746] shadow-sm";
    const getHoverClass = () => "hover:bg-[#F7F5EF] hover:text-[#263746] text-[#687482]";

    const adminLinks = [
        { to: "/admin", icon: <FaChartPie className="text-base" />, label: "Admin Command" },
        { to: "/products", icon: <FaBox className="text-base" />, label: "Catalogue View" },
    ];

    const customerLinks = [
        { to: "/customer", icon: <FaFileInvoiceDollar className="text-base" />, label: "My Enquiries & Quotes" },
        { to: "/products", icon: <FaBox className="text-base" />, label: "Browse Hardware" },
    ];

    const links = isAdmin ? adminLinks : customerLinks;

    return (
        <aside className="w-64 hidden md:flex flex-col border-r border-[#E5E7EB] bg-[#FFFFFF] relative overflow-hidden select-none">
            {/* Brand Header */}
            <div className="p-5 border-b border-[#E5E7EB] relative z-10">
                <Link to="/" className="block group">
                    <img
                        src="/logo.png"
                        alt="LUMIGO Projection Solutions"
                        className="h-9 w-auto object-contain mb-2 group-hover:opacity-90 transition"
                    />
                    <div className="flex items-center gap-2">
                        <img src="/favicon.png" alt="LUMIGO Aperture" className="w-4 h-4 object-contain" />
                        <span className="text-[10px] text-[#E3B629] font-black tracking-widest uppercase">
                            {isAdmin ? "Administrator Portal" : "Commercial Client Portal"}
                        </span>
                    </div>
                </Link>
            </div>

            {/* Navigation Links */}
            <nav className="flex-1 p-4 space-y-2 relative z-10">
                {links.map((item, idx) => (
                    <NavLink
                        key={idx}
                        to={item.to}
                        end
                        className={({ isActive }) =>
                            `${linkBase} ${isActive ? getActiveClass() : getHoverClass()}`
                        }
                    >
                        {item.icon}
                        <span>{item.label}</span>
                    </NavLink>
                ))}

                <div className="pt-6 border-t border-[#E5E7EB] mt-6">
                    <NavLink
                        to="/"
                        className="flex items-center gap-3 px-4 py-3 rounded-xl text-xs font-bold uppercase tracking-wider text-[#687482] hover:text-[#263746] hover:bg-[#F7F5EF] transition"
                    >
                        <FaArrowLeft />
                        <span>Return to Website</span>
                    </NavLink>
                </div>
            </nav>

            {/* Footer Status */}
            <div className="p-4 border-t border-[#E5E7EB] relative z-10 bg-[#F7F5EF]">
                <div className="text-[10px] text-[#687482] font-mono truncate">
                    Logged as: <span className="text-[#263746] font-bold">{user?.email}</span>
                </div>
                <div className="text-[9px] text-[#E3B629] uppercase font-black mt-0.5">
                    Role: {user?.role}
                </div>
            </div>
        </aside>
    );
};

export default Sidebar;
